import {createContext, useContext, ReactNode} from 'react'

type SSEContextType = {
    eventSource: EventSource | null
}

const SSEContext = createContext<SSEContextType>({eventSource: null})

export const SSEProvider = ({eventSource, children}: {eventSource: EventSource | null; children: ReactNode}) => {
    return <SSEContext.Provider value={{eventSource}}>{children}</SSEContext.Provider>
}

export const useSSEContext = () => useContext(SSEContext)
